"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Icon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _hideVisually = _interopRequireDefault(require("../../../../theming/styles/hideVisually"));

var _Upload = _interopRequireDefault(require("../../../Icons/Upload"));

var _themeContants = require("../../../../constants/themeContants");

var _theming = require("../../../../theming");

var _ThemeComponent = _interopRequireDefault(require("../../../Theme/ThemeComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var tinycolor = require("tinycolor2");

var FileInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FileInput, _Component);

  function FileInput(props, context) {
    var _this;

    _classCallCheck(this, FileInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileInput).call(this, props, context));
    _this.fileInput = _react["default"].createRef(); // To get the number of uploaded files from the input in case of multiple files

    _this.state = {
      uploadedFile: null
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FileInput, [{
    key: "handleChange",
    value: function handleChange(e) {
      var value = e.target.value;

      if (this.fileInput.current.files.length > 1) {
        this.setState({
          uploadedFile: this.fileInput.current.files.length + " " + this.props.multipleFilesLabel
        });
      } else if (value.length) {
        this.setState({
          uploadedFile: this.props.showFileName ? value.split("\\").pop() : "1 " + this.props.singleFileLabel
        });
      }

      this.props.onChange && this.props.onChange(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          id = _this$props.id,
          disabled = _this$props.disabled,
          className = _this$props.className,
          variant = _this$props.variant,
          accept = _this$props.accept,
          multiple = _this$props.multiple,
          onChange = _this$props.onChange,
          restProps = _objectWithoutProperties(_this$props, ["children", "id", "disabled", "className", "variant", "accept", "multiple", "onChange"]);

      return _react["default"].createElement(FileWrapper, {
        variant: variant,
        className: className,
        title: this.state.uploadedFile
      }, _react["default"].createElement(Input, _extends({
        type: "file",
        ref: this.fileInput // To get the number of uploaded files from the input in case of multiple files
        ,
        accept: accept,
        id: id,
        disabled: disabled,
        onChange: this.handleChange,
        multiple: multiple,
        variant: variant
      }, restProps)), _react["default"].createElement(Label, {
        htmlFor: id,
        variant: variant
      }, _react["default"].createElement(Icon, {
        variant: variant
      }), _react["default"].createElement("span", null, this.state.uploadedFile ? this.state.uploadedFile : children)));
    }
  }]);

  return FileInput;
}(_react.Component);

FileInput.themeProps = {
  wrapper: {
    name: "FileInput_Wrapper",
    description: "FileInput wrapper style",
    type: _themeContants.themePropTypes.style
  },
  input: {
    name: "FileInput_Input",
    description: "Input style – default is hidden! Style the label instead.",
    type: _themeContants.themePropTypes.style
  },
  label: {
    name: "FileInput_Label",
    description: "Label style",
    type: _themeContants.themePropTypes.style
  },
  icon: {
    name: "FileInput_Icon_Style",
    description: "Icon style",
    type: _themeContants.themePropTypes.style
  },
  iconComponent: {
    name: "FileInput_Icon_Component",
    description: "Icon component",
    type: _themeContants.themePropTypes.component
  }
};

var FileWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FileInput__FileWrapper",
  componentId: "sc-1xzndzh-0"
})(["", ";"], (0, _theming.applyVariants)(FileInput.themeProps.wrapper));

var Input = _styledComponents["default"].input.withConfig({
  displayName: "FileInput__Input",
  componentId: "sc-1xzndzh-1"
})(["", ";", ";"], _hideVisually["default"], (0, _theming.applyVariants)(FileInput.themeProps.input));

var Label = _styledComponents["default"].label.withConfig({
  displayName: "FileInput__Label",
  componentId: "sc-1xzndzh-2"
})(["cursor:pointer;background-color:", ";color:", ";border-width:0;border-radius:", ";padding:", " ", ";cursor:pointer;min-height:", ";text-decoration:none;text-align:center;display:inline-block;font-size:", ";font-family:", ";line-height:32px;font-weight:", ";white-space:nowrap;justify-content:center;align-items:center;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transition:background 0.2s ease;> span{display:flex;align-items:center;}&:hover,&:focus{outline:none;background-color:", ";color:", ";}", ";"], _theming.color.primary, function (p) {
  return tinycolor.mostReadable(_theming.color.primary()(p), ["#fff"], {
    includeFallbackColors: true,
    level: "AA",
    size: "large"
  }).toString();
}, _theming.borderRadius, _theming.spacing.tiny, _theming.spacing.medium, _theming.targetSize.normal, _theming.font.base, _theming.fontFamily.body, _theming.fontWeight.bold, function (p) {
  return tinycolor(_theming.color.primary()(p)).darken(5).toString();
}, function (p) {
  return tinycolor.mostReadable(tinycolor(_theming.color.primary()(p)).darken(5), ["#fff"], {
    includeFallbackColors: true,
    level: "AA",
    size: "large"
  }).toString();
}, (0, _theming.applyVariants)(FileInput.themeProps.label));

var IconComponent = function IconComponent(_ref) {
  var props = _extends({}, _ref);

  return _react["default"].createElement(_ThemeComponent["default"], _extends({
    tagName: FileInput.themeProps.iconComponent,
    fallback: _Upload["default"]
  }, props));
};

var Icon = (0, _styledComponents["default"])(IconComponent).withConfig({
  displayName: "FileInput__Icon",
  componentId: "sc-1xzndzh-3"
})(["display:block;height:12px;width:12px;margin-right:3px;", ";"], (0, _theming.applyVariants)(FileInput.themeProps.icon));
exports.Icon = Icon;
FileInput.propTypes = {
  accept: _propTypes["default"].string,
  children: _themeContants.commonPropTypes.children.isRequired,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  input: _propTypes["default"].any,
  onChange: _propTypes["default"].func,
  className: _propTypes["default"].string,
  ignoreBase: _propTypes["default"].func,
  variant: _propTypes["default"].string,
  multipleFilesLabel: _propTypes["default"].string,
  singleFileLabel: _propTypes["default"].string,
  showFileName: _propTypes["default"].bool
};
FileInput.defaultProps = {
  disabled: false,
  input: {},
  onChange: null,
  className: "",
  multipleFilesLabel: "files",
  singleFileLabel: "file",
  showFileName: true
};
var _default = FileInput;
exports["default"] = _default;